import React from 'react';
import styled from 'styled-components';
import get from 'lodash/get';
import { I18n } from 'react-redux-i18n';

import SelectFilter from 'components/Select/SelectFilter';

import { getNameNetwork } from 'modules/Prices/helpers';
import { Wine, Option, WineOption, MarketOption } from 'interface';
import { FilterEvolutionPricesOptions } from 'interface/price';
import { components } from 'apiTyped/types';

const EvolutionPriceFiltersContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.75);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 30px;
  padding: 30px 20px;
`;

const EvolutionPriceFilters = ({
  options,
  wine,
  setWine,
  vintage,
  setVintage,
  network,
  setNetwork,
  market,
  onChangeMarket,
  getWineData,
  disabled = false
}: {
  options: FilterEvolutionPricesOptions;
  wine: Wine | null;
  // eslint-disable-next-line no-unused-vars
  setWine: (e: Wine) => void;
  vintage: string | null;
  // eslint-disable-next-line no-unused-vars
  setVintage: (e: string) => void;
  network: string | null;
  // eslint-disable-next-line no-unused-vars
  setNetwork: (e: string) => void;
  market: MarketOption | null;
  // eslint-disable-next-line no-unused-vars
  onChangeMarket: (e: MarketOption | null) => void;
  getWineData: (
    // eslint-disable-next-line no-unused-vars
    e: number
  ) => components['schemas']['PriceEvolutionWine'] | undefined;
  disabled?: boolean;
}) => {
  const onChangeWine = (value: WineOption) => {
    if (wine && value.value === wine.id) return;

    onChangeMarket(null);
    setWine({ id: value.value, name: value.label });
    // if actual selected vintage in not on vintages new wine
    // then set default vintage
    const vintages = get(getWineData(value.value), 'vintages', []);
    // @ts-expect-error, always string
    if (vintage && vintages.length > 0 && !vintages.includes(vintage)) {
      setVintage(vintages[0]);
    }
  };

  const onChangeVintage = (value: Option) => {
    if (value.value === vintage) return;
    onChangeMarket(null);
    setVintage(value.value);
  };

  const onChangeNetwork = (value: Option) => {
    if (value.value === network) return;
    onChangeMarket(null);
    setNetwork(value.value);
  };

  return (
    <EvolutionPriceFiltersContainer>
      <SelectFilter
        selectedOption={wine ? { label: wine.name, value: wine.id } : null}
        options={options.wines}
        isClearable={false}
        placeholder={I18n.t('prices.filters.placeholderWine')}
        label={I18n.t('prices.filters.wine2')}
        onChange={onChangeWine}
        isDisabled={disabled}
      />
      <SelectFilter
        selectedOption={vintage ? { label: vintage, value: vintage } : null}
        isClearable={false}
        options={options.vintages}
        placeholder={I18n.t('prices.filters.placeholderVintage')}
        label={I18n.t('prices.filters.vintage')}
        onChange={onChangeVintage}
        isDisabled={disabled}
      />
      <SelectFilter
        selectedOption={
          network ? { label: getNameNetwork(network), value: network } : null
        }
        isClearable={false}
        options={options.networks}
        placeholder={I18n.t('prices.filters.placeholderNetwork')}
        label={I18n.t('prices.filters.network')}
        onChange={onChangeNetwork}
        isDisabled={disabled}
      />
      <SelectFilter
        selectedOption={market}
        isClearable={true}
        options={options.markets}
        placeholder={I18n.t('placeholderAll')}
        label={I18n.t('prices.filters.market')}
        onChange={onChangeMarket}
        isDisabled={disabled}
      />
    </EvolutionPriceFiltersContainer>
  );
};

export default EvolutionPriceFilters;
